import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBookVolumesAction } from '../../../../module/action/Book';
import { getCategoriesPostAction } from '../../../../module/action/Category';
import { createPostAction, getPostAction, updatePostStatusAction } from '../../../../module/action/Post';
import FormPost from '../../components/FormPost';
import PostFormData from '../../components/PostFormData';
import Spinner from '../../../../Constants/Spinner';
import DropDownIcon from '../../../../Assets/Icons/DropDownIcon';
import PublishIcon from '../../../../Assets/Icons/PublishIcon';
import DraftIcon from '../../../../Assets/Icons/DraftIcon';
import { DEFAULT_POST_CONTENT } from '../../utils/constants';
import { toast } from 'react-toastify';

function NewPost() {
  const dispatch = useDispatch();
  const bookData = useSelector(e => e.Book.bookData);
  const volumesData = useSelector(e => e.Book.volumesData);
  const getCategoriesPostData = useSelector(e => e.Category.getCategoriesPostData);
  const createPostLoader = useSelector(e => e.Post.createPostLoader);
  const getBookPost = useSelector(e => e.Post.getBookPost);

  /** Forcing form editor to re-render */
  const [postFormKey, setPostFormKey] = useState(0);

  const [getBookPostData, setGetBookPost] = useState([]);

  const [categoriesArr, setCategoriesArr] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [audioName, setAudioName] = useState('');

  const [bookId, setBookId] = useState('');
  const [volumeId, setVolumeId] = useState('');
  const [bookObj, setBookObj] = useState({
    book: '',
    volume: '',
  });

  const [postObj, setPostObj] = useState({
    reference: '',
    post_number: '',
    content: DEFAULT_POST_CONTENT,
    recitation_audio: '',
  });
  const [disabled, setDisable] = useState(false);
  const [publishLoader, setPublishLoader] = useState(false);
  const [draftLoader, setDraftLoader] = useState(false);
  useEffect(() => {
    if (publishLoader || draftLoader) {
      setDisable(true);
    } else if (postObj.reference && postObj.post_number && postObj.content) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [postObj, publishLoader, draftLoader]);
  useEffect(() => {
    if (getCategoriesPostData?.data?.length > 0) {
      setCategoriesArr(state => [...state, getCategoriesPostData.data]);
    }
  }, [getCategoriesPostData]);

  const getCat = refiD => {
    dispatch(getCategoriesPostAction(bookId, refiD));
  };

  useEffect(() => {
    if (bookId) {
      dispatch(getBookVolumesAction(bookId));
      dispatch(getCategoriesPostAction(bookId, ''));
    }
  }, [bookId]);

  useEffect(() => {
    dispatch(getPostAction(bookId, volumeId, bookId, selectedCategories));
  }, [bookId, volumeId, selectedCategories]);

  const clearState = () => {
    setPostObj({
      reference: '',
      post_number: '',
      content: DEFAULT_POST_CONTENT,
      recitation_audio: '',
    });
    setPostFormKey(state => state + 1);
    setAudioName('');
  };

  const confirmPost = setConfirmLoader => {
    let obj = {
      ...postObj,
      ...bookObj,
      categories: selectedCategories,
      date_post: new Date().toISOString(),
      status: 'unsaved',
    };
    dispatch(createPostAction(obj, clearState, setConfirmLoader));
  };

  useEffect(() => {
    setGetBookPost(getBookPost);
  }, [getBookPost]);

  const updateStatus = status => {
    let post = getBookPostData.map(a => {
      return a._id;
    });

    let obj = {
      post: post,
      status: status,
    };
    toast.success(status === 'draft' ? 'Post saved in draft' : 'Post published');
    dispatch(updatePostStatusAction(obj, status === 'draft' ? setDraftLoader : setPublishLoader));
  };

  return (
    <div className="NewPost my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <h2 className="text-[32px] font-[Poppins-Bold] ">New Post</h2>
        </div>
      </div>
      <div className="formPost mt-[56px]">
        <div className="chooseBook mb-[32px]">
          <div className="flex justify-between items-center">
            <p className='mb-6 font-bold font-["Poppins-ExtraBold"] '>1. Choose Book</p>
          </div>
          <div className="bookDetail flex flex-wrap items-center justify-between px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full">
            <div className="md:w-[32%] w-full">
              <p className="text-sm text-black font-semibold">Book Name</p>
              <label className="w-full h-[56px] relative flex items-center  mt-[16px]">
                <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />

                <select
                  value={bookObj.book}
                  className="selectInput rounded-xl text-[14px]  border-[1px] border-[#dde4de] h-full  w-full px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let obj = { ...bookObj };
                    obj.book = ev.target.value;
                    obj.volume = '';
                    setBookObj(obj);
                    setBookId(ev.target.value);
                    setCategoriesArr([]);
                    setSelectedCategories([]);
                  }}>
                  <option className="hidden">Choose book</option>
                  {bookData &&
                    bookData.map((a, i) => (
                      <option key={i} value={a._id}>
                        {a.bookName}
                      </option>
                    ))}
                  {/* <option>Book 2</option> */}
                </select>
              </label>
            </div>
            <div className="md:w-[32%] w-full">
              <p className="text-sm text-black font-semibold">Choose Volume</p>
              <label className="w-full h-[56px] relative flex mt-[16px] items-center">
                <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />
                <select
                  value={bookObj.volume}
                  disabled={!volumesData}
                  className="selectInput rounded-xl  text-[14px] border-[1px] border-[#dde4de] h-full  w-full px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let obj = { ...bookObj };
                    obj.volume = ev.target.value;
                    setVolumeId(ev.target.value);
                    setBookObj(obj);
                  }}>
                  <option className="hidden">Choose Volume</option>
                  {volumesData &&
                    volumesData.map((a, i) =>
                      a.volume_name ? (
                        <option key={i} value={a._id}>
                          {a.volume_name}
                        </option>
                      ) : null
                    )}
                  {/* <option>Volume 2</option> */}
                </select>
              </label>
            </div>
            <div className="w-[32%] md:block hidden">
              {/* <p className='text-sm text-black font-semibold'>Book Name</p>
                            <select className='selectInput rounded-xl  border-[1px] border-[#dde4de] w-full h-[56px] px-6 outline-none text-[#7b867c]'>
                                <option disabled>Choose book</option>
                                <option>Book 1</option>
                                <option>Book 2</option>
                            </select> */}
            </div>
          </div>
        </div>
        {categoriesArr.length > 0 && (
          <div className="chooseBook mb-[32px]">
            <div className="flex justify-between flex-wrap items-center md:flex-row flex-col">
              <p className='mb-6 font-bold md:w-auto w-full font-["Poppins-ExtraBold"]'>2. Coose Location</p>
            </div>
            <div className="locationDetail flex flex-wrap items-center justify-start px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full">
              {categoriesArr.map((categorieArr, i) => (
                <div className="lg:w-[24%] md:w-[48%] w-full ml-2 mt-2">
                  <p className="text-sm text-black font-semibold">{(i === 0 ? 'Parent ' : 'Sub-') + 'Category'}</p>
                  <label className="w-full h-[56px] relative flex mt-[16px] items-center">
                    <DropDownIcon className="pointer-events-none absolute z-[1] right-[22px]" />
                    <select
                      value={selectedCategories[i]}
                      className="selectInput rounded-xl  text-[14px] border-[1px] border-[#dde4de] h-full  w-full px-6 outline-none text-[#7b867c]"
                      onChange={ev => {
                        setSelectedCategories(state => {
                          let arr = state.slice(0, i + 1);
                          arr[i] = ev.target.value;
                          return arr;
                        });

                        setCategoriesArr(state => state.slice(0, i + 1));

                        getCat(ev.target.value);
                      }}>
                      <option className="hidden">Select</option>
                      {categorieArr.map((a, i) => (
                        <option key={i} value={a._id}>
                          {a.category_name}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
        {Boolean(selectedCategories[0]) ? (
          <div className="postDetail mb-[32px]">
            <div className="flex justify-between items-center">
              <p className=' font-bold font-["Poppins-ExtraBold"]'>3. Post Details</p>
            </div>
            {getBookPostData &&
              getBookPostData.map((a, i) => <FormPost data={a} postNumber={i + 1} getBookPostData={getBookPostData} />)}
            <PostFormData
              /* Forcing form editor to re-render */
              key={postFormKey}
              isPostLoading={false}
              postObj={postObj}
              setPostObj={setPostObj}
              audioName={audioName}
              setAudioName={setAudioName}
              getBookPostData={getBookPostData}
              formFunction={confirmPost}
            />
            <div className="mt-6 flex items-center flex-wrap">
              <button
                className="relative rounded-xl md:mr-4 md:mb-0 mb-4 text-white bg-[#2a9134] py-3.5 px-12 flex items-center justify-center md:w-auto w-[100%] disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => updateStatus('post')}>
                {publishLoader ? <Spinner /> : null}
                <span
                  className={
                    publishLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                  }>
                  <PublishIcon className="mr-[6px]" />
                  Publish Posts
                </span>
              </button>
              <button
                disabled={disabled}
                className="rounded-xl text-white bg-black py-3.5 px-12 flex items-center justify-center md:w-auto w-[100%] disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => updateStatus('draft')}>
                {draftLoader ? <Spinner /> : null}
                <span
                  className={
                    draftLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
                  }>
                  <DraftIcon className="mr-[6px]" />
                  Save to Drafts
                </span>
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default NewPost;
